import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import CustomTooltip from '../../../Tooltip';
import PreviewOriginal from '../../../PreviewOriginal';
import config from '../../../../config';
import { useTemplateConfig } from '../../../../context/TemplateConfigContext';
import ClipboardCopy from "../../../../helpers/ClipboardCopy";
import CustomNotify from "../../../Notify";
import DataComponentPromo from "../../../DataComponent/DataComponentPromo";

const columnTableData = {
    header: {
        0: {className: 'text-center', style: {width: 50}},
        1: {className: 'offer-item__table-banner', style: {width: 187}},
        2: {className: 'text-center'},
        3: {className: 'text-center'},
        4: {className: 'text-center'},
        5: {className: 'text-center'},
    },
    body: {
        0: {className: 'text-center'},
        1: {className: 'offer-item__table-banner'}
    }
};

const images = {
    iconList: require('shared_img/icons/icon-list.svg'),
};

const OfferPagePromoLinks = ({ 
    params, 
    location, 
    links, 
    publisherIsReferral, 
    totalPages, 
    headerNames, 
    loading, 
    showConstructor, 
    showConstructorPromoCode, 
    showConstructorPromoCodeList, 
    deletePromoCode, 
    getLinks, 
    t 
}) => {
    const { assets } = useTemplateConfig();

    const offerId = useMemo(() => {
        return params?.id || location?.params?.id || null;
    }, [params, location]);

    const [state, setState] = useState({
        links: links,
        publisherIsReferral: publisherIsReferral
    });

    const referralBadges = (t && t.referral) || {};

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            links: links
        }));
    }, [links]);

    const showConstructorHandler = useCallback((linkId) => {
        if (showConstructor) {
            showConstructor({'linkId': linkId});
        }
    }, [showConstructor]);

    const onClickEditPromoCode = useCallback((linkId, promoCode) => {
        if (showConstructorPromoCode) {
            showConstructorPromoCode({'linkId': linkId, 'promocode': promoCode});
        }
    }, [showConstructorPromoCode]);

    const onClickDeletePromoCode = useCallback((promoCodeId) => {
        let updatedLinks = state.links.map(link => ({
            ...link,
            promo_codes: link.promo_codes.filter(promoCode => promoCode.id !== promoCodeId)
        }));

        setState(prevState => ({
            ...prevState,
            links: updatedLinks
        }));

        deletePromoCode(promoCodeId, t, () => {}, () => {});
    }, [state.links, deletePromoCode, t]);

    const onClickClipBoard = useCallback((promoCode) => {
        ClipboardCopy.copy(promoCode);
        CustomNotify(promoCode);
    }, []);

    const showConstructorPromoCodeListHandler = useCallback((link) => {
        if (showConstructorPromoCodeList) {
            showConstructorPromoCodeList({'link': link});
        }
    }, [showConstructorPromoCodeList]);

    const renderBadge = useCallback((link) => {
        let advertiserIsReferral = link.offer.advertiser.referral_advertiser,
            offerIsReferral = link.offer.referral_offer;

        if (state.publisherIsReferral && advertiserIsReferral && offerIsReferral) {
            return (
                <span className="badge badge-danger ml10" title={referralBadges.link}>RL</span>
            )
        }
        return null;
    }, [state.publisherIsReferral, referralBadges]);

    const getLinksData = useCallback(() => {
        let linksData = [];
        let staticNames = t?.offersPage?.offer || {};

        state.links.map((link, i) => {
            let itemUrl = link.url.slice(0, 60);
            if (itemUrl.length < link.url.length) {
                itemUrl += '...';
            }

            let itemTitle = link.title.slice(0,50);
            if (itemTitle.length < link.title.length) {
                itemTitle += '...';
            }

            linksData.push({
                id: link.id,
                name: link.title,
                image: (
                    <div className="offer-item__table-img">
                        {link.thumbnail
                            ? (
                                <CustomTooltip id={`link-preview-${i}`} tooltip={<PreviewOriginal url={link.image} />} placement={'right'} theme={'preview'}>
                                    <a href={link.url} id={`link-preview-${i}`} target="_blank">
                                        <img src={link.thumbnail || assets.cap} alt="" />
                                    </a>
                                </CustomTooltip>
                            )
                            : (
                                <a href={link.url} target="_blank">
                                    <img src={assets.cap} alt="" />
                                </a>
                            )
                        }
                    </div>
                ),
                title: itemTitle,
                url:(<a href={link.url} target="_blank">{itemUrl}</a>),
                action: (
                    <div className="offer-item__promo-links-wrap">
                        <div className={"offer-item__promo-links-toolbar"}>
                            <button
                                className="btn btn-white generate-link"
                                onClick={() => { showConstructorHandler(link.id); }}
                            >
                                {staticNames.generateLink} {renderBadge(link)}
                            </button>
                        </div>
                        {config.allowGeneratePromocodes
                            ? (
                                <div className="offer-item__promo-links-toolbar-promo">
                                    <button
                                        className="btn btn-white generate-link"
                                        onClick={() => { onClickEditPromoCode(link.id); }}
                                    >
                                        {staticNames.generatePromoCode}
                                    </button>
                                    <CustomTooltip
                                        id={`${link.id}_tooltip`}
                                        tooltip={t?.constructors?.promocodes}
                                    >
                                        <button
                                            className={link.promo_codes && link.promo_codes.length > 0 ? "btn promo-code-list" : "btn promo-code-list empty"}
                                            onClick={() => { showConstructorPromoCodeListHandler(link); }}
                                            disabled={link.promo_codes && link.promo_codes.length <= 0}
                                        >
                                            <span><img src={images.iconList} alt="promocode list"/></span>
                                        </button>
                                    </CustomTooltip>
                                </div>
                            )
                            : (
                                <div className="offer-item__promo-links-toolbar-promo info">
                                    <button
                                        className={link.promo_codes && link.promo_codes.length > 0 ? "btn btn-white generate-link" : "btn btn-white generate-link empty"}
                                        onClick={() => { showConstructorPromoCodeListHandler(link); }}
                                        disabled={link.promo_codes && link.promo_codes.length <= 0}
                                    >
                                        {staticNames.promocodes}
                                    </button>
                                </div>
                            )
                        }
                    </div>
                ),
                selfLink: link.selfie_link ? 'Selfie' : staticNames.defaultLink,
                actions: link.promo_codes.length ? (
                    <div className="offer-item__promo-links-wrap">
                        {link.promo_codes.map((promoCode) => (
                            <div className="row-controls row-controls_small" key={promoCode.id}>
                                <CustomTooltip
                                    placement={'left'}
                                    theme={'preview'}
                                    tooltip={t?.constructors?.copy}
                                >
                                    <a className="control-item"
                                       data-index={promoCode.id}
                                       onClick={() => {onClickClipBoard(promoCode.title); }}>
                                        <span className="fa fa-copy" />
                                    </a>
                                </CustomTooltip>
                                <CustomTooltip
                                    placement={'left'}
                                    theme={'preview'}
                                    tooltip={t?.constructors?.editPromocode}
                                >
                                    <a className="control-item"
                                       data-index={promoCode.id}
                                       onClick={() => {onClickEditPromoCode(link.id, promoCode); }}
                                    >
                                        <span className={config.allowGeneratePromocodes ? "fa fa-pencil-square-o" : "fa fa-eye"} />
                                    </a>
                                </CustomTooltip>
                                {(() => {
                                    if (config.allowGeneratePromocodes) {
                                        return <CustomTooltip
                                            placement={'left'}
                                            theme={'preview'}
                                            tooltip={t?.actions?.delete}
                                        >
                                            <a className="control-item"
                                               data-index={promoCode.id}
                                               onClick={() => { onClickDeletePromoCode(promoCode.id); }}
                                            >
                                                <span className="fa fa-trash-o" />
                                            </a>
                                        </CustomTooltip>
                                    }
                                })()}
                            </div>
                        ))}
                    </div>
                ) : null
            });
        });

        return linksData;
    }, [state.links, state.publisherIsReferral, showConstructorHandler, onClickEditPromoCode, showConstructorPromoCodeListHandler, renderBadge, onClickClipBoard, onClickDeletePromoCode, t]);

    const onDataTableAction = useCallback((state, actionType) => {
        getLinks({
            ...state,
            offer_ids: offerId
        }, actionType);
    }, [getLinks, offerId]);

    const linksData = useMemo(() => getLinksData(), [getLinksData]);

    return (
        <DataComponentPromo
            onAction={onDataTableAction}
            totalPages={totalPages}
            headerNames={headerNames}
            data={linksData}
            loading={loading}
            withoutDatepicker={true}
            textInput={true}
            alignPagination={true}
            columnData={columnTableData}
            hidden={false}
        />
    );
};

OfferPagePromoLinks.propTypes = {
    params: PropTypes.object,
    location: PropTypes.object,
    links: PropTypes.array,
    publisherIsReferral: PropTypes.bool,
    totalPages: PropTypes.number,
    headerNames: PropTypes.array,
    loading: PropTypes.bool,
    showConstructor: PropTypes.func,
    showConstructorPromoCode: PropTypes.func,
    showConstructorPromoCodeList: PropTypes.func,
    deletePromoCode: PropTypes.func,
    getLinks: PropTypes.func,
    t: PropTypes.object
};

OfferPagePromoLinks.defaultProps = {
    links: [],
    publisherIsReferral: false,
    totalPages: 0,
    headerNames: [],
    loading: false,
    showConstructor: () => {},
    showConstructorPromoCode: () => {},
    showConstructorPromoCodeList: () => {},
    deletePromoCode: () => {},
    getLinks: () => {}
};

export default withTranslation(OfferPagePromoLinks);